import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export default function ComingSoon({ sequenceNumber }) {
  return (
    <Box>
      <Typography
        variant={`h6`}
        sx={{ minHeight: "70vh", pt: 5 }}
        textAlign={"center"}
      >
        Coming soon!
        <br />
        {sequenceNumber}
      </Typography>
    </Box>
  );
}
